<template>
    <div>
        <div class="list-title">
            <h3>Notificaciones</h3>
        </div>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row>
                    <v-flex>
                        <v-layout row wrap>
                            <v-flex xs12 sm3>
                                <v-text-field
                                    class='lance'
                                    v-model="search.code"
                                    label="Código"
                                    @input="searchOnTable">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm3>
                                <v-text-field
                                    class='lance'
                                    v-model="search.name"
                                    label="Nombre"
                                    @input="searchOnTable">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm3>
                                <v-select class="lance"
                                    :items="status"
                                    item-text="internalText"
                                    item-value="id"
                                    v-model="search.status"
                                    label="Estatus"
                                    @input="searchOnTable"
                                    multiple>
                                    <v-list-tile v-if="search.status" slot="prepend-item" @click="search.status = null; searchOnTable();">
                                        <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                        <v-list-tile-title>Limpiar</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider v-if="search.status" slot="prepend-item" class="mt-2"></v-divider>
                                </v-select>
                            </v-flex>
                            <v-flex xs12 sm3>
                                <v-select class="lance"
                                    :items="users"
                                    item-text="username"
                                    item-value="id"
                                    v-model="search.users"
                                    label="Usuarios"
                                    @input="searchOnTable"
                                    multiple>
                                    <v-list-tile v-if="search.users" slot="prepend-item" @click="search.users = null; searchOnTable();">
                                        <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                        <v-list-tile-title>Limpiar</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider v-if="search.supplier" slot="prepend-item" class="mt-2"></v-divider>
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex shrink>
                    <v-btn fab v-if="credentials.NotificationConfigurationCreate" color="primary" @click="goTo('Notificationform')">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :pagination.sync="pagination"
            class="table-catalog elevation-5">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" @click="goTo('Notificationform/' + props.item.id)">
                <tr v-bind:class="{ itemToDelete: props.item.id == itemToDelete }"
                    class="cursor-pointer"
                    @click="credentials.NotificationConfigurationRead? goTo('Notificationdetail/' + props.item.id): null">
                    <td class="text-xs-left">{{ props.item.code }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.status }}</td>
                    <td class="text-xs-left">{{ props.item.users }}</td>
                    <td class="text-xs-right">
                        <v-btn fab small color="primary" 
                            v-if="credentials.NotificationConfigurationUpdate" 
                            @click.stop="goTo('Notificationform/' + props.item.id)">
                            <img src="@/assets/icon-editar.svg" alt="">
                        </v-btn>
                        <v-btn fab small color="error" 
                            v-if="credentials.NotificationConfigurationDelete" 
                            @click.stop="confirmDelete(props.item.id)">
                            <img src="@/assets/icon-eliminar.svg" alt="">
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; deleteRegistry(itemToDelete)">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>
    .table-catalog >>> table.v-table thead th:not(:first-child):not(:last-child),
    .table-catalog >>> table.v-table tbody td:not(:first-child):not(:last-child) {
        padding-left: 30px;
    }

    .table-catalog >>> table.v-table thead th:not(:nth-last-child(2)):not(:last-child),
    .table-catalog >>> table.v-table tbody td:not(:nth-last-child(2)):not(:last-child) {
        padding-right: 30px;
    }

    .table-catalog >>> table.v-table thead th:last-child,
    .table-catalog >>> table.v-table tbody td:last-child {
        padding-left: 0px;
    }

    .table-catalog >>> table.v-table thead th:last-child,
    .table-catalog >>> table.v-table tbody td:last-child {
        padding-right: 0px;
    }

    .table-catalog >>> table.v-table thead tr th {
        font-size: 18px;
        font-weight: bold;
    }

    .table-catalog >>> table.v-table tbody tr td {
        font-size: 14px;
    }
</style>



<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';

    export default {
        data () {
            return {
                list: [],
                source: [],
                status: [],
                users: [],
                search: {
                    code: "",
                    name: "",
                    status: null,
                    users: null,
                },
                headers: [
                    { text: 'Código', value: 'code' },
                    { text: 'Nombre', value: 'name' },
                    { text: 'Estatus', value: 'status' },
                    { text: 'Usuarios', value: 'users' },
                    { text: '', value: 'delete', align: 'center', sortable: false, width: "100px" },
                ],
                pagination: {
                    sortBy: "",
                    descending: false
                },
                loading: true,
                deleteDialog: false,
                itemToDelete: '',
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            confirmDelete: function(id) {
                this.itemToDelete = id;
                this.deleteDialog = true;
            },
            goTo(url) {
                this.$router.push('/' + url);
            },
            getList: function() {
                return this.$http.get('NotificationConfiguration')
                    .then(response => {
                        var list = response.body;
                        this.list = list;
                        this.source = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    })
            },
            getStatus(value) {
                let s = this.status.find(x => x.id == value);
                return s? s.internalText: "";
            },
            getUser(value) {
                let s = this.users.find(x => x.id == value);
                return s? s.username: "";
            },
            getStatuses: function() {
                return this.$http.get('Status')
                    .then(response => {
                        var list = response.body;
                        this.status = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de estatus');
                        console.error(error);
                    });
            },
            getUsers: function() {
                return this.$http.get('NotificationConfiguration/user')
                    .then(response => {
                        var list = response.body;
                        this.users = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de usuarios');
                        console.error(error);
                    })
            },
            setupList() {
                for (let item of this.list) {
                    if (item.NotificationConfigurationStatus.length) {
                        item.statusIds = _.pluck(item.NotificationConfigurationStatus, 'status');
                        item.status = (item.statusIds.map(x => this.getStatus(x))).join(', ');
                    }
                    if (item.NotificationConfigurationUsers.length) {
                        item.userIds = _.pluck(item.NotificationConfigurationUsers, 'userId');
                        item.users = (item.userIds.map(x => this.getUser(x))).join(', ');
                    }
                }
                this.source = this.list;
            },
            deleteRegistry(id) {
                this.showConfirm = false;
                this.$http.delete('NotificationConfiguration/' + id)
                    .then(response => {
                        this.itemToDelete = '';
                        this.getList();
                        this.snackbar('El registro ha sido eliminado con éxito');
                    }, error => {
                        this.itemToDelete = '';
                        this.snackbar('Hubo un problema al eliminar el registro');
                        console.error(error);
                    });
            },
            searchOnTable: function() {
                this.list = _.filter(this.source, item => {
                    let statusEval = this.search.status ? (this.search.status.filter(x => item.statusIds.includes(x))).length > 0 : true;
                    let usersEval = this.search.users ? (this.search.users.filter(x => item.userIds.includes(x))).length > 0 : true;
                    return statusEval && usersEval && (!this.search.code || item.code && item.code.toLowerCase().includes(this.search.code.toLowerCase()))
                        && item.name.toLowerCase().includes(this.search.name.toLowerCase());
                });
            },
        },
        mounted() {
            let promises = [
                this.getUsers(),
                this.getStatuses(),
                this.getList(),
            ];
            Promise.all(promises).then( results => {
                this.setupList();
                this.loading = false;
            });
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        }
    }
</script>